import {FC, ReactNode} from 'react'
import styles from './SidebarSection.module.css'

interface SidebarSectionProps {
  children: ReactNode
}
export const SidebarSection: FC<SidebarSectionProps> = ({children}): JSX.Element => <div className={styles.SidebarSectionContainer}>{children}</div>
